import { addNotify } from 'features/notify';
import { getErrorMessage } from 'shared/helpers/getErrorMessage';

export const actionTypes = {
  GET_CASHBACK_LIST_REQUEST: 'cashback/GET_CASHBACK_LIST_REQUEST',
  GET_CASHBACK_LIST_SUCCESS: 'cashback/GET_CASHBACK_LIST_SUCCESS',
  GET_CASHBACK_LIST_FAILURE: 'cashback/GET_CASHBACK_LIST_FAILURE',
  CREATE_CASHBACK_REQUEST: 'cashback/CREATE_CASHBACK_REQUEST',
  CREATE_CASHBACK_SUCCESS: 'cashback/CREATE_CASHBACK_SUCCESS',
  CREATE_CASHBACK_FAILURE: 'cashback/CREATE_CASHBACK_FAILURE',
  DELETE_CASHBACK_REQUEST: 'cashback/DELETE_CASHBACK_REQUEST',
  DELETE_CASHBACK_SUCCESS: 'cashback/DELETE_CASHBACK_SUCCESS',
  DELETE_CASHBACK_FAILURE: 'cashback/DELETE_CASHBACK_FAILURE',
  SET_CURRENT_PAGE: 'cashback/SET_CURRENT_PAGE',
  SET_ITEMS_ON_PAGE: 'cashback/SET_ITEMS_ON_PAGE',
};

const getCashbackListRequest = () => ({ type: actionTypes.GET_CASHBACK_LIST_REQUEST });
const getCashbackListSuccess = data => ({ type: actionTypes.GET_CASHBACK_LIST_SUCCESS, payload: data });
const getCashbackListFailure = error => ({ type: actionTypes.GET_CASHBACK_LIST_FAILURE, payload: error });

const createCashbackRequest = () => ({ type: actionTypes.CREATE_CASHBACK_REQUEST });
const createCashbackSuccess = () => ({ type: actionTypes.CREATE_CASHBACK_SUCCESS });
const createCashbackFailure = error => ({ type: actionTypes.CREATE_CASHBACK_FAILURE, payload: error });

const deleteCashbackRequest = () => ({ type: actionTypes.DELETE_CASHBACK_REQUEST });
const deleteCashbackSuccess = id => ({ type: actionTypes.DELETE_CASHBACK_SUCCESS, payload: id });
const deleteCashbackFailure = error => ({ type: actionTypes.DELETE_CASHBACK_FAILURE, payload: error });

export const actions = {
  getCashbackList:
    params =>
    async (dispatch, getState, { api }) => {
      dispatch(getCashbackListRequest());
      try {
        const response = await api.cashback.getCashbackList(params);

        if (response.success && response.data) {
          dispatch(getCashbackListSuccess(response.data));
        } else {
          dispatch(getCashbackListSuccess({ items: [], count: 0 }));
        }
      } catch (error) {
        console.log('❌ Error in getCashbackList:', error);
        const { locale } = getState().locale;
        const errorMessage = getErrorMessage(locale, error);
        dispatch(addNotify(errorMessage, 'error'));
        dispatch(getCashbackListFailure(error.message));
      }
    },

  createCashback:
    (data, callback) =>
    async (dispatch, getState, { api }) => {
      dispatch(createCashbackRequest());
      const { locale } = getState().locale;

      try {
        const response = await api.cashback.createCashback(data);

        if (response.success) {
          dispatch(addNotify(locale.cashbackCreatedSuccess || locale.defaultSuccess, 'success'));
          dispatch(createCashbackSuccess());

          const { currentPage, itemsOnPage } = getState().cashback;
          const skip = currentPage * itemsOnPage;
          dispatch(actions.getCashbackList({
            skip,
            limit: itemsOnPage,
          }));

          callback && callback();
        } else {
          const errorMessage = getErrorMessage(locale, response);
          dispatch(addNotify(errorMessage, 'error'));
          dispatch(createCashbackFailure(errorMessage));
        }
      } catch (error) {
        const errorMessage = getErrorMessage(locale, error);
        dispatch(addNotify(errorMessage, 'error'));
        dispatch(createCashbackFailure(error.message));
      }
    },

  deleteCashback:
    (id, callback) =>
    async (dispatch, getState, { api }) => {
      dispatch(deleteCashbackRequest());
      const { locale } = getState().locale;

      try {
        const response = await api.cashback.deleteCashback({ id });

        if (response.success) {
          dispatch(addNotify(locale.cashbackDeletedSuccess || locale.defaultSuccess, 'success'));
          dispatch(deleteCashbackSuccess(id));

          const { currentPage, itemsOnPage } = getState().cashback;
          const skip = currentPage * itemsOnPage;
          dispatch(actions.getCashbackList({
            skip,
            limit: itemsOnPage,
          }));

          callback && callback();
        } else {
          const errorMessage = getErrorMessage(locale, response);
          dispatch(addNotify(errorMessage, 'error'));
          dispatch(deleteCashbackFailure(errorMessage));
        }
      } catch (error) {
        const errorMessage = getErrorMessage(locale, error);
        dispatch(addNotify(errorMessage, 'error'));
        dispatch(deleteCashbackFailure(error.message));
      }
    },

  setCurrentPage: page => ({
    type: actionTypes.SET_CURRENT_PAGE,
    payload: page,
  }),

  setItemsOnPage: itemsOnPage => ({
    type: actionTypes.SET_ITEMS_ON_PAGE,
    payload: itemsOnPage,
  }),
};
